// extracted by mini-css-extract-plugin
export var gif = "_go-0";